import { render, staticRenderFns } from "./Resume_guest.vue?vue&type=template&id=c5a0b002&scoped=true&"
import script from "./Resume_guest.vue?vue&type=script&lang=js&"
export * from "./Resume_guest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a0b002",
  null
  
)

export default component.exports